import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
export function useEscapeKey(enabled, handler) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== enabled || $[1] !== handler) {
    t0 = () => {
      if (!enabled) {
        return;
      }
      const onKeyDown = function onKeyDown(e) {
        if (e.key === "Escape") {
          handler();
        }
      };
      document.addEventListener("keydown", onKeyDown);
      return () => document.removeEventListener("keydown", onKeyDown);
    };
    t1 = [enabled, handler];
    $[0] = enabled;
    $[1] = handler;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}